/** @format */

import {
  GET_IC,
  GET_IC_MODAL,
  GET_SOCIOS_SOCIEDADES,
  GET_SOCIOS_SOCIEDADES_MODAL,
  GET_DETALLE_CONYUGE,
  GET_DETALLE_CONYUGE_MODAL,
  GET_DETALLE_DIRECCIONES,
  GET_DETALLE_DIRECCIONES_MODAL,
  GET_DETALLE_PROPIEDADES_BIENES,
  GET_DETALLE_PROPIEDADES_BIENES_MODAL,
  GET_DETALLE_BOLETIN,
  GET_DETALLE_VEHICULO,
  GET_DETALLE_VEHICULO_MODAL,
  ASIGNO_DIGITO_VERIFICADOR,
  ASIGNO_RUT_CONSULTA,
  GET_VERIFICACION,
  GET_DOCUMENT_PCH,
  GET_DETALLE_EXTRACTO,
  ASIGNO_NSERIES_EMPRESA,
  ASIGNO_ESTADO_CARGA,
  GetOnp,
  GetBanco,
  AuthLogin,
  loading_Auth,
  AuthLogout,
  GetPerfil,
  GetPermisos,
  GetContraInfoCom,
  GetContraVerifOnp,
  GET_DETALLE_BOLETIN_MODAL,
  GET_ESTRUCTURA_FINANCIERA,
  GET_ESTRUCTURA_FINANCIERA_MODAL,
  GetSoporte,
  GetUsuarios,
  GetResumen,
  GetDetalle,
  GetResumenGrafico,
  GetSKL,
  GetProducts,
  LogoutAll,
  SklLogin,
  GetUrlBase,
  get_TipoContrato,
  GetConsumoSaldno,
  STATE_OK_LOADING_IC,
  code_error,
} from "../types";

const UserReducer = (state, action) => {
  const { payload, type } = action;

  switch (type) {
    case GET_IC:
      return {
        ...state,
        datoIC: payload,
        datoICPDF: payload,
        stateLoading: true,
      };
    case GET_IC_MODAL:
      return {
        ...state,
        datoICMODAL: payload,
      };
    case GET_SOCIOS_SOCIEDADES:
      return {
        ...state,
        DatoListaSA: payload,
        DatoListaSApdf: payload,
      };
    case GET_SOCIOS_SOCIEDADES_MODAL:
      return {
        ...state,
        DatoListaSAModal: payload,
        DataListaSAModalPdf: payload,
      };

    case GET_DETALLE_CONYUGE:
      return {
        ...state,
        Datodetalleconyuge: payload,
      };
    case GET_DETALLE_CONYUGE_MODAL:
      return {
        ...state,
        DatodetalleconyugeModal: payload,
      };

    case GET_DETALLE_DIRECCIONES:
      return {
        ...state,
        DatodetalleDirecciones: payload,
      };
    case GET_DETALLE_DIRECCIONES_MODAL:
      return {
        ...state,
        DatodetalleDireccionesModal: payload,
      };
    case GET_DETALLE_PROPIEDADES_BIENES:
      return {
        ...state,
        DatodetallePropBienes: payload,
      };
    case GET_DETALLE_PROPIEDADES_BIENES_MODAL:
      return {
        ...state,
        DatodetallePropBienesModal: payload,
      };

    case GET_DETALLE_BOLETIN:
      return {
        ...state,
        DatodetalleBoletin: payload,
        DatodetalleBoletinpdf: payload,
      };
    case GET_DETALLE_BOLETIN_MODAL:
      return {
        ...state,
        DatodetalleBoletinModal: payload,
        DatodetalleBoletinpdfModal: payload,
      };

    case GET_DETALLE_VEHICULO:
      return {
        ...state,
        DatodetalleVehiculos: payload,
      };

    case GET_DETALLE_VEHICULO_MODAL:
      return {
        ...state,
        DatodetalleVehiculosModal: payload,
      };
    case ASIGNO_DIGITO_VERIFICADOR:
      return {
        ...state,
        DvValidado: payload,
      };
    case ASIGNO_RUT_CONSULTA:
      return {
        ...state,
        RutValidado: payload,
      };
    case ASIGNO_NSERIES_EMPRESA:
      return {
        ...state,
        SerieCedulaNatu: payload,
      };
    case GET_VERIFICACION:
      return {
        ...state,
        DatodetalleVerificacion: payload,
      };
    case GET_DETALLE_EXTRACTO:
      return {
        ...state,
        DatadetalleExtracto: payload,
      };
    case ASIGNO_ESTADO_CARGA:
      return {
        ...state,
        stateLoading: payload,
      };

    case GET_DOCUMENT_PCH:
      return {
        ...state,
        DatodetalleDocumentpch: payload,
      };

    case GET_ESTRUCTURA_FINANCIERA:
      return {
        ...state,
        dataDetalleEstructura: payload,
      };

    case GET_ESTRUCTURA_FINANCIERA_MODAL:
      return { ...state, dataDetalleEstructuraModal: payload };

    case GetOnp:
      return {
        ...state,
        DataOnp: payload,
      };
    case GetBanco:
      return {
        ...state,
        DataBanco: payload,
      };

    case AuthLogin:
      return {
        ...action.payload,
        ...state,
        logged: true,
        DataLogin: payload,
      };
    case AuthLogout:
      return {
        logged: false,
      };
    case GetPerfil:
      return {
        ...state,
        DataPerfil: payload,
      };
    case GetPermisos:
      return {
        ...state,
        DataPermisos: payload,
      };
    case GetContraInfoCom:
      return {
        ...state,
        DataContatoInfoCom: payload,
      };
    case GetContraVerifOnp:
      return {
        ...state,
        DataContratoVerifOnp: payload,
      };
    case GetSoporte:
      return {
        ...state,
        DataSoporte: payload,
      };
    case GetUsuarios:
      return {
        ...state,
        DataUsuarios: payload,
      };
    case GetResumen:
      return {
        ...state,
        DataResumen: payload,
      };
    case GetDetalle:
      return {
        ...state,
        DataDetalle: payload,
      };
    case GetResumenGrafico:
      return {
        ...state,
        DataResumenGrafico: payload,
      };
    case GetSKL:
      return {
        ...state,
        SklDecode: payload,
      };
    case GetProducts:
      return {
        ...state,
        DataProducts: payload,
      };
    case get_TipoContrato:
      return {
        ...state,
        DataTipoContracto: payload,
      };
    case GetConsumoSaldno:
      return {
        ...state,
        DataSaldo: payload,
      };
    case LogoutAll:
      return {
        ...state,
        DataLogoutAll: payload,
      };

    case SklLogin:
      return {
        ...action.payload,
        logged: true,
        DataLoginSkl: action.payload,
      };

    case GetUrlBase:
      return {
        ...state,
        dataUrlBase: payload,
      };

    case STATE_OK_LOADING_IC:
      return { ...state, statOkLoading: payload };

    case loading_Auth:
      return { ...state, loadingAuth: payload };

    case code_error:
      return { ...state, codeError: payload };

    default:
      return state;
  }
};
export default UserReducer;
